import classNames from 'classnames';
import t from 'rcm-i18n';
import React from 'react';

import './style.scss';

interface Props {
    accepted: boolean;
    onAccept: () => void;
}

const CookieNoticeBanner = ({ accepted, onAccept }: Props) => (
    <div className={classNames({ accepted }, 'cookie-notice-banner')}>
        <div className="row">
            <div className="col-xs-12 col-sm-7 col-md-8">
                {t('This site uses cookies.')}&nbsp;
                <a href="/cookie-notice">{t('Cookie Policy')}</a>
            </div>
            <div className="col-xs-12 col-sm-5 col-md-4 right">
                <div className="right-inner">
                    <a href="/cookie-notice"
                        className="cookie-settings-link"
                    >
                        <span className="glyphicon glyphicon-chevron-right" />
                        <span className="link-text">{t('Cookie Settings')}</span>
                    </a>
                    <button className="btn btn-success" onClick={onAccept}>
                        {t('Accept Cookies')}
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default CookieNoticeBanner;
